/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2020 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import React from 'react';

import { defineMessages } from '@nebula/izzy/intl';
import Button from '@react/react-spectrum/Button';
import InfoOutline from '@react/react-spectrum/Icon/InfoOutline';
import OverlayTrigger from '@react/react-spectrum/OverlayTrigger';
import Tooltip from '@react/react-spectrum/Tooltip';

import Copy from '@nebula/luna/dist/core/copy';

const MSG = defineMessages({
  info: {
    id: 'gemini.session.pin.info',
    defaultMessage: 'Enter this pin on the device to which you are trying to connect.'
  },
  label: {
    id: 'gemini.session.pin.label',
    defaultMessage: 'Enter PIN'
  }
});
const pinField = ({
  izzy,
  pin,
  ...props
}) => (
  <React.Fragment>
    <div {...props}>
      <Copy
        style={{
          display: 'inline-block',
          verticalAlign: '-webkit-baseline-middle'
        }}
        variant="label"
      >
        {izzy(MSG.label)}
      </Copy>
      <OverlayTrigger
        placement="bottom"
        trigger="click"
      >
        <Button
          variant="action"
          quiet
          type="button"
          icon={<InfoOutline />}
        />
        <Tooltip>{izzy(MSG.info)}</Tooltip>
      </OverlayTrigger>
    </div>
    { pin !== '' && (
      <span
        data-test-id="pin"
        className="spectrum-Heading1--display spectrum-Heading1--quiet"
      >
        {pin}
      </span>
    )}
  </React.Fragment>
);

pinField.displayName = 'pinField';

export default pinField;
